export default __webpack_public_path__ + "d36ad5c42cb5088560c6301e7f7f8480.svg";